import React from 'react';

const WhatsAppButton = () => {
  const phoneNumber = '+919953003900';
  const whatsappGifPath = `${process.env.PUBLIC_URL}/assets/img/whatsapp.gif`;
  
  const handleWhatsAppRedirect = () => {
    // Format: Remove the + and any spaces for WhatsApp API
    const formattedNumber = phoneNumber.replace(/[+\s]/g, '');
    window.open(`https://api.whatsapp.com/send?phone=${formattedNumber}`, '_blank');
  };
  
  return (
    <div className="whatsapp-button" onClick={handleWhatsAppRedirect} title="Chat with us on WhatsApp">
      <img src={whatsappGifPath} alt="WhatsApp Chat" />
    </div>
  );
};

export default WhatsAppButton; 